module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/pagination/first-9747419c0fc6a5d806a2e2c71aa4fa2f.svg";